import React from 'react'

export default function Cookies() {
    return (
        <div className="section__cookies wf-section">
            <div className="center">
                <div className="cookies__container">
                    <div className="cookies__text"><strong className="bold-text-2">
                        Política de privacidade </strong>
                        <br />Este site usa cookies e dados pessoais de acordo com a nossa
                        <a href="#" className="link-2">Política de Privacidade</a> e, ao continuar navegando neste site, 
                        você declara estar ciente dessas condições.
                    </div>
                    <a href="#" className="cookies__button">ACEITAR<br /></a>
                </div>
            </div>
        </div>
    )
}
